import {
	Directive,
	Input,
	HostListener,
	ElementRef,
	OnInit,
	forwardRef
} from '@angular/core';

import {
	ControlValueAccessor,
	NG_VALUE_ACCESSOR,
	NG_VALIDATORS,
	ValidationErrors,
	AbstractControl
} from '@angular/forms';

@Directive({
	selector: 'input[nullIfEmpty]',
	standalone: false,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => NullIfEmptyDirective),
			multi: true
		},
	]
})
export class NullIfEmptyDirective implements OnInit, ControlValueAccessor {

	@Input('value') innerValue: string|number|null = null;

	private el: HTMLInputElement;


	constructor(private elementRef: ElementRef) {
		this.el = this.elementRef.nativeElement;
	}

	onChange: any = () => { };
	onTouched: any = () => { };

	ngOnInit() {

	}

	get value() {
		return this.innerValue;
	}

	set value(value: string|number|null) {
		this.innerValue = value;
		this.onChange(value);
		this.onTouched();
	}

	registerOnChange(fn: any) {
		this.onChange = fn;
	}

	registerOnTouched(fn: any) {
		this.onTouched = fn;
	}

	writeValue(value: string|number|null) {
		if (typeof value != 'undefined') {
			this.innerValue = value;
		}
	}


	@HostListener('input', ['$event'])
	input($event: any) {
		let value = $event.target.value;
		if (typeof value == 'string') {
			value.trim();
			let length = value.length;
			if (!length) value = null;
		}
		this.innerValue = value;
		this.onChange(this.innerValue);
	}

}
